import app from './app';

class ContentBlocker {
    constructor() {
        this.container = document.documentElement;
        this.pageOffset = 0;
        this._isBlocked = false;
        this.sources = {};
        this.scrollbarSize = null;
    }

    block(source) {
        this.sources[source] = true;
        if (!this._isBlocked) {
            if (app.isTouch) {
                this.pageOffset = window.pageYOffset;
                this.container.classList.add('is-blocked-touch');
                this.container.style.top = -this.pageOffset + 'px';
            } else {
                this.container.classList.add('is-blocked');

                if (this.hasScrollBar()) {
                    this.container.style.marginRight = this.getScrollbarSize() + 'px';
                }
            }
            this._isBlocked = true;
        }
    }

    unblock(source) {
        this.sources[source] = false;
        if (this.isFree() && this._isBlocked) {
            if (app.isTouch) {
                this.container.style.top = 'initial';
                this.container.classList.remove('is-blocked-touch');
                window.scrollTo(0, this.pageOffset);
            } else {
                this.container.classList.remove('is-blocked');
                this.container.style.marginRight = '0';
            }
            this._isBlocked = false;
        }
    }

    isBlocked(source) {
        return this.sources[source] === true;
    }

    isFree() {
        return Object.keys(this.sources).every((key) => this.sources[key] === false);
    }

    hasScrollBar() {
        return (
            document.body.scrollHeight >
            document.documentElement.clientHeight
        );
    }

    getScrollbarSize() {
        if (this.scrollbarSize === null) {
            const scrollDiv = document.createElement('div');

            scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
            document.body.appendChild(scrollDiv);
            this.scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
        return this.scrollbarSize;
    }
}

const instance = new ContentBlocker();

export default instance;
